/* eslint-disable array-callback-return */
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
//import { CostUnit, displayCost } from 'utilities/currencyFormatter';
import logoTrcGlobal from './images/trc-full-logo-condensed.jpg';
import { getSelectedClientInformation } from 'utilities/authUtils';

export const getTravelPartyCost = (cost, accompanyingAdults) => {
    const count = Number(accompanyingAdults);
    const additionalTravelers = Number.isFinite(count) && count >= 0 ? count : 0;
    return cost * (1 + additionalTravelers);
};

export const getGrossUpAmount = (benefits, savedBenefits, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, avgHomesalePrice, avgHomesalePriceOrigin, applyTaxGrossUp, getOptionCost, grossUpPercentage) => {
    let total = 0;
    let grossUpAmount = 0;

    benefits.filter((b) => savedBenefits.find((sb) => sb.benefitNumber === b.benefitNumber)).map((benefit) => {
        let currentSavedBenefit = savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber);

        if (benefit.options && Array.isArray(benefit.options) && currentSavedBenefit.options && Array.isArray(currentSavedBenefit.options)) {
            benefit.options.map((opt) => {
                let currentSavedOption = currentSavedBenefit.options.find((csbo) => csbo.optionNumber === opt.optionNumber);

                if (currentSavedOption) {
                    const optCost = getOptionCost(opt, currentSavedOption);
                    total = total + optCost;
                }
            })
        }

        // Add custom line cost if applicable
        if (currentSavedBenefit.customLineChecked && currentSavedBenefit.customLineCost) {
            total = total + Number(currentSavedBenefit.customLineCost);
        }

        // Only add benefit-level cost if it's not a customTotal benefit
        // (customTotal benefits like Relocation Allowance already return their cost via getOptionCost)
        const benefitLevelCost = Number(currentSavedBenefit.cost) || 0;
        if (!benefit.customTotal) {
            total = total + benefitLevelCost;
        } 
    });
    if (applyTaxGrossUp) {
        let reloAllowanceBen = savedBenefits.find((sb) => sb.benefitNumber === 8);
        let homeSaleBen = savedBenefits.find((sb) => sb.benefitNumber === 5);
        let homePurchasingBen = savedBenefits.find((sb) => sb.benefitNumber === 4);
        let taxableTotal = total;

        if (reloAllowanceBen && !reloAllowanceBen.isTaxable) {
            taxableTotal -= Number(reloAllowanceBen.cost) || 0;
        }
        if (homeSaleBen && !topLevelInputFive) {
            // Get the actual saved cost from the benefit option
            let homeSaleOption = homeSaleBen.options.find((opt) => opt.optionNumber === 21);
            let homeSaleCost = 0;
            if (homeSaleOption) {
                let benefit = benefits.find((b) => b.benefitNumber === 5);
                let opt = benefit?.options.find((o) => o.optionNumber === 21);
                if (opt) {
                    homeSaleCost = getOptionCost(opt, homeSaleOption);
                }
            }
            taxableTotal -= homeSaleCost;
        }
        if (homePurchasingBen && !topLevelInputEight) {
            // Get the actual saved cost from the benefit option
            let homePurchasingOption = homePurchasingBen.options.find((opt) => opt.optionNumber === 19);
            let homePurchasingCost = 0;
            if (homePurchasingOption) {
                let benefit = benefits.find((b) => b.benefitNumber === 4);
                let opt = benefit?.options.find((o) => o.optionNumber === 19);
                if (opt) {
                    homePurchasingCost = getOptionCost(opt, homePurchasingOption);
                }
            }
            taxableTotal -= homePurchasingCost;
        }
        grossUpAmount = taxableTotal * (grossUpPercentage * 0.01);
    }

    return grossUpAmount;
}

export const getTotalEstimateAmount = (benefits, savedBenefits, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, avgHomesalePrice, avgHomesalePriceOrigin, applyTaxGrossUp, getOptionCost, grossUpPercentage) => {
    let total = 0;

    benefits.filter((b) => savedBenefits.find((sb) => sb.benefitNumber === b.benefitNumber)).map((benefit) => {
        let currentSavedBenefit = savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber);

        if (benefit.options && Array.isArray(benefit.options) && currentSavedBenefit.options && Array.isArray(currentSavedBenefit.options)) {
            benefit.options.map((opt) => {
                let currentSavedOption = currentSavedBenefit.options.find((csbo) => csbo.optionNumber === opt.optionNumber);

                if (currentSavedOption) {
                    const optCost = getOptionCost(opt, currentSavedOption);
                    total = total + optCost;
                }
            })
        }

        // Add custom line cost if applicable
        if (currentSavedBenefit.customLineChecked && currentSavedBenefit.customLineCost) {
            total = total + Number(currentSavedBenefit.customLineCost);
        }

        // Only add benefit-level cost if it's not a customTotal benefit
        // (customTotal benefits like Relocation Allowance already return their cost via getOptionCost)
        const benefitLevelCost = Number(currentSavedBenefit.cost) || 0;
        if (!benefit.customTotal) {
            total = total + benefitLevelCost;
        } 
    });

    if (applyTaxGrossUp) {
        total += getGrossUpAmount(benefits, savedBenefits, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, avgHomesalePrice, avgHomesalePriceOrigin, applyTaxGrossUp, getOptionCost, grossUpPercentage);
    }

    return total;
}

export const exportToExcelWithStyles = async (savedBenefits, benefits, fileName, getOptionCost, totalEstimateAmount, grossUpAmount, estimateInfo, distance, policyName) => {
    const workbook = new ExcelJS.Workbook();

    const worksheet = workbook.addWorksheet('Cost Estimate', {
        // Ensures the estimate data fits on one page when printed
        pageSetup:{fitToPage: false, scale: 75, orientation: 'landscape'}
    });

    worksheet.properties.defaultColWidth = 35;
    worksheet.properties.defaultRowHeight = 25;
    worksheet.views = [{ showGridLines: false }];

    const clientInfo = getSelectedClientInformation();

    const imageResp = await fetch(logoTrcGlobal);
    const arrayBuffer = await imageResp.arrayBuffer();

    const imageId1 = workbook.addImage({
        buffer: arrayBuffer,
        extension: 'png',
    });
    worksheet.addImage(imageId1, {
        tl: { col: 0, row: 0 },
        ext: { width: 220, height: 90 }
    });
    worksheet.getCell('B1').value = estimateInfo.transfereeName;
    worksheet.getCell('B1').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    worksheet.getCell('C1').value = clientInfo.description;
    worksheet.getCell('C1').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    worksheet.getCell('B2').value = `Exported on ${new Date().toLocaleDateString()}`;
    worksheet.getCell('B2').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    worksheet.getCell('C2').value = `Family Member(s): ${estimateInfo.accompanyingAdults}`;
    worksheet.getCell('C2').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    worksheet.getCell('B3').value = `${estimateInfo.origin.formattedAddress} to ${estimateInfo.destination.formattedAddress}`;
    worksheet.getCell('B3').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    worksheet.getCell('C3').value = `Move Miles: ${distance}`;
    worksheet.getCell('C3').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};

    worksheet.getCell('B4').value = `Ownership Type: ${estimateInfo.reloPolicy ? estimateInfo.reloPolicy : 'N/A'}`;
    worksheet.getCell('B4').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    worksheet.getCell('C4').value = `Policy Name: ${policyName}`;
    worksheet.getCell('C4').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};

    worksheet.mergeCells('A6:C11');
    worksheet.getCell('C11').value = 'Note: This worksheet makes a number of assumptions based on information gathered from various sources. The numbers contained below are strictly estimates and should not be construed as final as they are subject to change. When the employee relocation proceeds, the moving company will conduct a survey (virtual or in person) with the employee in which an estimate will be provided based on actual inventory and services needed. ';
    worksheet.getCell('C11').font = { bold: true, size: 12, color: { argb: 'FF0000' } };
    worksheet.getCell('C11').alignment = { wrapText: true };
    worksheet.getCell('C11').border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};

    const reloBenefitsDividerRow = worksheet.addRow(['Relocation Benefits', '', '']);
    reloBenefitsDividerRow.getCell(1).font = { bold: true, size: 14, color: { argb: 'FFFFFF' } };
    reloBenefitsDividerRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bababa' } }; 
    reloBenefitsDividerRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}};
    reloBenefitsDividerRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bababa' } };
    reloBenefitsDividerRow.getCell(2).border = {top: {style:'thin'}, bottom: {style:'thin'}};
    reloBenefitsDividerRow.getCell(3).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bababa' } };
    reloBenefitsDividerRow.getCell(3).border = {top: {style:'thin'}, right: {style:'thin'}, bottom: {style:'thin'}};

    benefits.map((b) => {
        let savedBenefit = savedBenefits.find((sb) => sb.benefitNumber === b.benefitNumber);
        if (savedBenefit) {
            let topLevelSelectionText = '';
            if (b.topLevelInputOne) {
                const optionOneDetails = b.topLevelInputOne.options.find((details) => details.id === estimateInfo.topLevelInputOneId);
                const optionTwoDetails = b.topLevelInputTwo.options.find((details) => details.id === estimateInfo.topLevelInputTwoId);
                topLevelSelectionText = `(${optionOneDetails ? optionOneDetails.label : ''}, ${optionTwoDetails ? optionTwoDetails.label : ''})`;
            } else if (b.topLevelInputThree) {
                const optionThreeDetails = b.topLevelInputThree.options.find((details) => details.id === estimateInfo.topLevelInputThreeId);
                topLevelSelectionText = `(${optionThreeDetails ? optionThreeDetails.label : ''})`;
            } else if (b.topLevelInputFour) {
                const optionFourDetails = b.topLevelInputFour.options.find((details) => details.id === estimateInfo.topLevelInputFourId);
                topLevelSelectionText = `(${optionFourDetails ? optionFourDetails.label : ''})`;
            }

            const benefitTitleRow = worksheet.addRow([b.name, topLevelSelectionText, '']);
            benefitTitleRow.getCell(1).font = { bold: true };
            benefitTitleRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
            benefitTitleRow.getCell(2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            benefitTitleRow.getCell(2).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
            benefitTitleRow.getCell(3).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
            benefitTitleRow.height = 25;

            if (b.options && Array.isArray(b.options)) {
                b.options.map((staticOpt) => {
                    if (!savedBenefit.options || !Array.isArray(savedBenefit.options)) return null;
                    
                    let savedOpt = savedBenefit.options.find((sbo) => sbo.optionNumber === staticOpt.optionNumber);

                    if (!savedOpt) return null;

                if (!savedOpt) return null;

                let optionText = '';
                let selectionText = '';
                if (staticOpt.selections && savedOpt && staticOpt.selections.find((os) => os.selectionId === savedOpt.selectionId)) {
                    optionText = staticOpt.description;
                    selectionText = `(${staticOpt.selections.find((os) => os.selectionId === savedOpt.selectionId).text})`;
                } else if (savedOpt && savedOpt.customDescription) {
                    optionText = savedOpt.customDescription;
                } else if (savedOpt && savedOpt.selectionId && staticOpt.freeNumberField) {
                    optionText = staticOpt.description;
                    selectionText = `(${savedOpt.selectionId} ${staticOpt.freeNumberMultiplier})`;
                } else if (savedOpt && staticOpt.optionNumber === 21 && estimateInfo.topLevelInputFive) {
                    optionText = 'Direct reimbursement (Subject to gross up)';
                } else if (b.customTotal) {
                    selectionText = savedBenefit.isTaxable ? '(Grossed Up)' : '(Not Grossed Up)';
                } else {
                    optionText = staticOpt.description;
                }

                const optionRow = worksheet.addRow([`     ${optionText}`, selectionText, staticOpt.customTotal ? Number(savedBenefit.cost) : Number(getOptionCost(staticOpt, savedOpt, b))]);
                optionRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
                optionRow.getCell(2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                optionRow.getCell(2).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
                optionRow.getCell(3).font = { bold: true };
                optionRow.getCell(3).numFmt = '$#,##0.00';
                optionRow.getCell(3).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
                optionRow.height = 25;
            });
            }

            if (savedBenefit.customLineChecked) {
                const customLineRow = worksheet.addRow([`     ${savedBenefit.customLineDescription}`, '', Number(savedBenefit.customLineCost)]);
                customLineRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
                customLineRow.getCell(2).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
                customLineRow.getCell(3).font = { bold: true };
                customLineRow.getCell(3).numFmt = '$#,##0.00';
                customLineRow.getCell(3).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
                customLineRow.height = 25;
            }

            // Buffer row between benefits
            worksheet.addRow(['', '', '']);
        }
    })

    const totalDividerRow = worksheet.addRow(['Estimated Total', '', '']);
    totalDividerRow.getCell(1).font = { bold: true, size: 14, color: { argb: 'FFFFFF' } };
    totalDividerRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bababa' } }; 
    totalDividerRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}};
    totalDividerRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bababa' } };
    totalDividerRow.getCell(2).border = {top: {style:'thin'}, bottom: {style:'thin'}};
    totalDividerRow.getCell(3).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bababa' } };
    totalDividerRow.getCell(3).border = {top: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    totalDividerRow.height = 25;

    const subtotalRow = worksheet.addRow(['     Subtotal', '', Number(totalEstimateAmount - grossUpAmount)]);
    subtotalRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    subtotalRow.getCell(2).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    subtotalRow.getCell(3).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    subtotalRow.getCell(3).font = { bold: true };
    subtotalRow.getCell(3).numFmt = '$#,##0.00';
    subtotalRow.height = 25;

    const grossUpRow = worksheet.addRow([`     Gross Up (${estimateInfo.grossUpPercentage}%)`, '', Number(grossUpAmount)]);
    grossUpRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    grossUpRow.getCell(2).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    grossUpRow.getCell(3).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    grossUpRow.getCell(3).font = { bold: true };
    grossUpRow.getCell(3).numFmt = '$#,##0.00';
    grossUpRow.height = 25;

    const totalRow = worksheet.addRow(['Total Estimated Move Cost', '', Number(totalEstimateAmount)]);
    totalRow.getCell(1).font = { bold: true, size: 14 };
    totalRow.getCell(1).border = {top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}};
    totalRow.getCell(3).font = { bold: true, size: 14 };
    totalRow.getCell(3).numFmt = '$#,##0.00'; 
    totalRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '90EE90' } }; 
    totalRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '90EE90' } };
    totalRow.getCell(2).border = {top: {style:'thin'}, bottom: {style:'thin'}};
    totalRow.getCell(3).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '90EE90' } };
    totalRow.getCell(3).border = {top: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'}};
    totalRow.height = 25;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `${fileName}.xlsx`);
};